import { render, staticRenderFns } from "./ThreadsHistory.vue?vue&type=template&id=41702e02&scoped=true"
import script from "./ThreadsHistory.vue?vue&type=script&lang=ts"
export * from "./ThreadsHistory.vue?vue&type=script&lang=ts"
import style0 from "./ThreadsHistory.vue?vue&type=style&index=0&id=41702e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41702e02",
  null
  
)

export default component.exports